import { useCallback, useState } from 'react';
import { Notification } from '../utils';
import socialAuthService from '../Services/social-auth.service';
import accessTokenService from '../Services/access-token.service';
import { useSearchParams } from 'react-router-dom';

const HOME_PAGE_ROUTE = process.env.REACT_APP_PUBLIC_HOME_PAGE || '';

const useGoogleAuth = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { dest } = Object.fromEntries(searchParams.entries());

  const googleSignInHandler = useCallback(async () => {
    try {
      setLoading(true);

      const data = await socialAuthService.signInWithGoogle();
      const accessToken = data.result?.accessToken;

      if (data.type === 'error' || !accessToken) {
        Notification.error({
          description: data.result?.message || 'An error occurred while signing in with Google.',
        });
        return;
      }

      accessTokenService.set(accessToken, false);

      const destination = dest || HOME_PAGE_ROUTE;
      if (destination) {
        window.location.href = destination;
      }
    } catch (error: any) {
      if (error?.code === 'auth/popup-closed-by-user' ||
        error?.code === 'auth/cancelled-popup-request') {
        return;
      }

      Notification.error({
        description: 'An unexpected error occurred while signing in with Google.',
      });
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [dest]);

  return { googleSignInHandler, loading };
};

export default useGoogleAuth;